/*

saiKrishna  10/06/2022  2699823790  Removed unecesarry console.log statements.
sohel  10/15/2022  2699823790  Triggers ->Added Code Comments.
Rohini  10/27/2022  2699823790  Triggers ->Added class name for table
Raghu 10/28/2022  2699823790 Table Icon changes
Prakash 10/30/2022  2699823790 Table Pagination changes
Ashraf 10/30/2022 2699823790 fixed table pagination issue
saikrishna 11/03/2022 2699823790 changed the paginationOptions
Suresh Peddavoora 11/03/2022 2699823790 Table Alignments Fixes
Dilip 11/03/2022 2699823790 Added  code in delete popup
Sohel 11/09/2022 2699823790 Added Action Table column condition
Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
Suresh Peddavoora 11/21/2022 2700271704- Fixed Table Spacing Alignments.
Akhila 11/22/2022 2699823790 Rename Delete Confirm message when PopUp DialogBox
Akhila 11/23/2022 2699823790 Rename Delete title from Delete Rule to Delete Action
akhila 11/26/2022 2699823790 Remove the action code
Rajesh 11/29/2022 2699823790 removed the agency tie
Sai Maheshwar 12/08/2022 2700271704 Fixed Alter fields on account payload  issue
Raghu 12/17/2022 2700271704 Table Footer Styling Fixes
Dilip 12/19/2022 2700271704 Changed delete action popup message
akhila 12/21/2022 2700271704 fixed rulegroup Datacalculation for labels
Ashraf 01/03/2023 2700271704 renamed disposition to status
Akhila 01/20/2023 2700271704 unsaved chnages alert popup issue fixed
Akhila 01/23/2023 2700271704 rename winodw name to respositoryName in table parameter
Guru Prasad 02/15/2023 2700271704 fixed drag and drop table alignments
Raghu 02/28/2023 2700271704 added new classname for tables
suresh peddavoora 03/28/2023 2700271704 table alignment fixes
Sohel 01/31/2023 2701334326 Action Dropdown Changes
Sohel 04/24/2023 2701334326 Fixed Edit API Issue
Ravi 05/31/2023 2701334326 changed delete popup message
uday 26/10/2023 2701334326 fixed Trigger Maintenance actions table ui bug
*/

import React, {createRef, useState} from 'react';
import {MTableBody, MTableBodyRow} from 'material-table';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import {makeStyles, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import {tablePageRows, defaultRows} from '../../../../constants/ReusableTablePagination';
import {useDispatch} from 'react-redux';
import moment from 'moment';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../../components/PageLoader';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {SetActionFormData as setActionFormData} from '../../../../redux/reducers/EventTactics/EventTactics';
const useStyles = makeStyles((theme) => ({
  tableButtonRoot: {
    'lineHeight': 1.75,
    [theme.breakpoints.down('md')]: {
      lineHeight: 1.5,
      padding: '6px 15px',
    },
    '& .MuiButton-label': {
      'fontSize': '0.813rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.625rem',
        letterSpacing: 1,
      },
      '& .MuiSvgIcon-root': {
        [theme.breakpoints.down('md')]: {
          width: '0.65em',
          height: '0.65em',
        },
      },
    },
  },
  actionTable: {
    '& .MuiTableRow-root': {
      color: 'inherit',
      display: 'table-row-group',
      outline: 0,
      verticalAlign: 'middle',
    },
    '& .MuiTableBody-root': {
      display: 'inline',
      textAlign: 'center',
    },
    '& .MuiTableSortLabel-root > div': {
      fontSize: '0.790rem !important',
      fontWeight: 'bold !important',
    },
    '& .MuiTableCell-body': {
      width: '100vw',
    },
    '& .MuiTableCell-root:nth-child(1) > div ': {
      width: '55px',
    },
    '& .MuiTablePagination-toolbar': {
      width: '100% !important',
    },
  },
}));

const applyToOptions = [
  {key: 'A', value: 'A - Account'},
  {key: 'S', value: 'S - Seed'},
  {key: 'R', value: 'R - Route'},
];

export default function ActionsTable({
  actionTableData,
  setAddActionDialogOpen,
  setActionTableData,
  setDeletedActionIds,
  deletedActionIds,
  setEditActionOpen,
  handleDirty,
}) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const tableRef = createRef();
  const [userData, setUserData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [loader, setLoader] = useState(false);

  // Action Table Columns(2700271704)
  const columns = [
    {
      title: 'SEQ No',
      field: 'seqNo',
      // maxWidth: "100px",
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        actionTableData[rowData.tableData.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Action(s)',
      field: 'action',
      textAlign: 'left',
      // cellStyle:{
      //   textAlign: "left",
      // },
      minWidth: '200px',
      render: (rowData) => {
        return (
          <div
            style={{
              // maxWidth: 350,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {`${rowData?.action?.value ? rowData?.action?.value : ''}`}
          </div>
        );
      },
    },
    {
      title: 'Parameter(s)',
      field: 'params',
      cellStyle: {
        wordBreak: 'break-all',
      },
      // minWidth: "700px",
      render: (rowData) => {
        const ar = [];
        Object.entries(rowData?.params).forEach(([key, value]) => {
          if (key === 'field') {
            value ?
              ar.push(`${key} : "${value?.fieldName ? value?.fieldName : value ? value : ''}"`) :
              null;
          } else if (key === 'ruleGroup') {
            value ?
              ar.push(
                  `dataCalculation : "${value?.fieldName ? value?.fieldName : value ? value : ''}"`,
              ) :
              null;
          } else if (key === 'dateStamp') {
            value ? ar.push(`${key} : "${value ? moment(value).format('MM-DD-YYYY') : ''}"`) : null;
          } else if (key === 'overRide') {
            value ? ar.push(`override : "${value}"`) : null;
          } else if (key === 'disposition') {
            value ? ar.push(`status : "${value}"`) : null;
          } else if (key === 'waitDays' || key === 'daysToWait') {
            value ? ar.push(`waitDate : "${value}"`) : null;
          } else if (key === 'waitDate') {
            value ?
              ar.push(`fixedWaitDate : "${value ? moment(value).format('MM-DD-YYYY') : ''}"`) :
              null;
          } else if (key === 'window') {
            value ? ar.push(`repositoryName : "${value}"`) : null;
          } else if (key === 'applyTo') {
            value ?
              ar.push(
                  `${key} : "${
                    value ? applyToOptions.filter((el) => el.key === value)[0]?.value : ''
                  }"`,
              ) :
              null;
          } else if (key === 'updateDateBy') {
            return;
          } else {
            value ? ar.push(`${key} : "${value}"`) : null;
          }
        });
        return (
          <div
            style={{
              // maxWidth: 800,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {ar.filter(Boolean).join(', ')}
          </div>
        );
        // let spiltingString = rowData?.params?.split(",");
        // let filteredParam = spiltingString?.filter((item) => item !== " Invalid date");
        // let emptyStringFilter = filteredParam?.filter((item) => item !== " ")?.join(",");
        // return <span style={{ whiteSpace: "pre-wrap" }}>{`${emptyStringFilter}`}</span>;
      },
    },
  ];

  // Drag Drop Action in Table(2700271704)
  const onDragEnd = (result) => {
    const {destination, source} = result;
    if (!destination) {
      return;
    }
    if (source.index !== destination.index) {
      const copyRows = [...actionTableData];
      const temp = actionTableData[source.index];
      copyRows.splice(source.index, 1);
      copyRows.splice(destination.index, 0, temp);
      setActionTableData(copyRows);
    }
  };

  // handle Delete Action(2700271704)
  const handleDelete = (rowData) => {
    setUserData(rowData);
    setIsDelete(true);
  };

  // closed delete popup(2700271704)
  const handleCloseDialog = () => {
    setIsDelete(false);
  };

  const [rows, setRows] = useState(defaultRows);

  // Delete Action(2700271704)
  const handleSubmit = () => {
    setLoader(true);
    return new Promise((resolve) => {
      setTimeout(() => {
        const data = [...actionTableData];
        const newData = data.filter((row) => row.seqNo !== userData.seqNo);
        const newDeletedIds = [...deletedActionIds];
        if (userData.actionId) {
          newDeletedIds.push(userData.actionId);
        }
        setDeletedActionIds(newDeletedIds);
        setActionTableData(newData);
        resolve();
        handleCloseDialog();
        setLoader(false);
      }, 1000);
      handleDirty(true);
    });
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Action"
        value={`Are you sure you want to delete the ${userData?.action?.value || ''} Action ?`}
        handleSubmit={handleSubmit}
      />
      <div
        className={`custom-table global-field-table triggerDrag-dropTable new-standard-textfields tablescroll-block ${classes.actionTable}`}
      >
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={actionTableData}
          textAlign="left"
          options={{
            pageSize: rows,
            search: false,
            pageSizeOptions: tablePageRows,
            toolbar: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
              fontSize: '0.938rem',
              padding: '16px',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer">
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              </div>
            ),
            Body: (props) => (
              <div>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                    {(provided) => (
                      <div ref={provided.innerRef}>
                        <MTableBody {...props} />
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            ),
            Row: (props) => (
              <Draggable
                draggableId={props.data.tableData.id.toString()}
                index={props.data.tableData.id}
              >
                {(provided) => (
                  <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                  >
                    <MTableBodyRow {...props} />
                  </div>
                )}
              </Draggable>
            ),
          }}
          actions={[
            {
              icon: () => <EditOutlinedIcon />,
              tooltip: 'Edit',
              onClick: (event, rowData) => {
                dispatch(setActionFormData({...rowData}));
                // dispatch(fetchEventTacticActionParams(rowData?.action?.valueCode));
                setEditActionOpen(true);
              },
            },
            {
              icon: () => <DeleteOutlineOutlinedIcon />,
              tooltip: 'Delete',
              onClick: (event, rowData) => handleDelete(rowData),
            },
          ]}
        />
        {loader && <PageLoader />}
      </div>
    </>
  );
}
